import {Component} from "@angular/core";

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss']
})
export class BreadCrumbComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/bread-crumb/bread-crumb.component.ts